import { ShareDetailsPageProvider } from '../pages/ShareDetails/context/ShareDetailsPageContext';
import ShareDetails from '../pages/ShareDetails';

const ShareDetailsPageContainer = () => (
  <ShareDetailsPageProvider>
    <ShareDetails />
  </ShareDetailsPageProvider>
);

export default ShareDetailsPageContainer;
